import { render, staticRenderFns } from "./ArtworXPreviewFieldDialogue.vue?vue&type=template&id=5bcef51f&"
import script from "./ArtworXPreviewFieldDialogue.vue?vue&type=script&lang=ts&"
export * from "./ArtworXPreviewFieldDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports